document.addEventListener("DOMContentLoaded", function () {
  const sliderSection = document.querySelector(".tripzo-slider-section");
  if (!sliderSection) return;

  const slideTrack = sliderSection.querySelector(".slide-track");

  let isAnimating = false;
  let autoplayTimer = null;
  const autoplayDelay = 4000;

  /* ── Text animation ── */
  function animateActiveTexts() {
    const activeItem = slideTrack.querySelector(".slide-item:nth-child(2)");
    if (!activeItem) return;

    const title     = activeItem.querySelector(".slide-title");
    const desc      = activeItem.querySelector(".slide-description");
    const actionBtn = activeItem.querySelector(".slide-action-btn");

    gsap.killTweensOf([title, desc, actionBtn]);

    gsap.fromTo(title,
      { y: 35, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.6, ease: "power3.out", delay: 0.1 }
    );
    gsap.fromTo(desc,
      { y: 20, opacity: 0 },
      { y: 0, opacity: 0.85, duration: 0.6, ease: "power3.out", delay: 0.25 }
    );
    if (actionBtn) {
      gsap.fromTo(actionBtn,
        { y: 15, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.5, ease: "power3.out", delay: 0.35 }
      );
    }
  }

  /* ── Ken Burns image animation ── */
  function animateActiveImage() {
    const activeItem = slideTrack.querySelector(".slide-item:nth-child(2)");
    if (!activeItem) return;

    const img = activeItem.querySelector(".slide-img");
    if (!img) return;

    gsap.killTweensOf(img);
    gsap.fromTo(img,
      { opacity: 0, scale: 1.08 },
      { opacity: 1, scale: 1.0, duration: 0.55, ease: "power2.out" }
    );
    gsap.fromTo(img,
      { scale: 1.0 },
      { scale: 1.10, duration: (autoplayDelay / 1000) + 0.5, ease: "none" }
    );
  }

  animateActiveTexts();
  animateActiveImage();

  function moveNext() {
    if (isAnimating) return;
    isAnimating = true;

    const items = slideTrack.querySelectorAll(".slide-item");
    if (items.length < 2) { isAnimating = false; return; }

    gsap.to(items[0], {
      opacity: 0,
      duration: 0.4,
      ease: "power2.out",
      onComplete: () => {
        slideTrack.appendChild(items[0]);
        gsap.set(items[0], { clearProps: "opacity,transform" });
        animateActiveTexts();
        animateActiveImage();
        isAnimating = false;
        startAutoplay();
      }
    });
  }

  function movePrev() {
    if (isAnimating) return;
    isAnimating = true;

    const items = slideTrack.querySelectorAll(".slide-item");
    if (items.length < 2) { isAnimating = false; return; }

    const lastItem = items[items.length - 1];
    gsap.set(lastItem, { opacity: 0 });
    slideTrack.insertBefore(lastItem, items[0]);

    gsap.to(lastItem, {
      opacity: 1,
      duration: 0.4,
      ease: "power2.out",
      onComplete: () => {
        animateActiveTexts();
        animateActiveImage();
        isAnimating = false;
        startAutoplay();
      }
    });
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(moveNext, autoplayDelay);
  }

  function stopAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
  }

  /* ── Thumbnail click → navigate to that slide ── */
  slideTrack.addEventListener("click", function (e) {
    const clickedItem = e.target.closest(".slide-item");
    if (!clickedItem) return;

    const items = Array.from(slideTrack.querySelectorAll(".slide-item"));
    const idx   = items.indexOf(clickedItem);

    // idx 0 = bg (offscreen), idx 1 = active, idx 2+ = thumbnails
    if (idx < 2 || isAnimating) return;

    stopAutoplay();

    // Move forward (idx-1) times to bring clicked thumb to active position
    const steps = idx - 1;
    let   count = 0;

    function stepNext() {
      if (count >= steps) {
        isAnimating = false;
        animateActiveTexts();
        animateActiveImage();
        startAutoplay();
        return;
      }
      count++;
      isAnimating = true;
      const currentItems = slideTrack.querySelectorAll(".slide-item");

      gsap.to(currentItems[0], {
        opacity: 0,
        duration: 0.3,
        ease: "power2.out",
        onComplete: () => {
          slideTrack.appendChild(currentItems[0]);
          gsap.set(currentItems[0], { clearProps: "opacity,transform" });
          stepNext();
        }
      });
    }

    stepNext();
  });

  startAutoplay();
});